import { BrowserRouter as Router } from 'react-router-dom'
import { AdminHome } from '@/components/admin/AdminHome/AdminHome'
import { AdminProducts } from '@/components/admin/AdminProducts/AdminProducts'
import { Analytics } from '@/components/admin/Analytics/Analytics'
import { Assets } from '@/components/admin/Assets/Assets'
import { CaseImageQc } from '@/components/admin/CaseImageQc/CaseImageQc'
import { Cases } from '@/components/dashboard/Cases/Cases'
import { CustomThemeEditorWrapper } from '@/components/customThemes/CustomThemeEditor/CustomThemeEditorWrapper'
import { CustomThemes } from '@/components/customThemes/CustomThemes'
import { Dashboard } from '@/components/dashboard/Dashboard'
import { Editor } from '@/components/editor/Editor'
import { EditorTextBoxFuneralHomeLimitPage } from '@/components/admin/EditorTextBoxFuneralHomeLimit/EditorTextBoxFuneralHomeLimitPage'
import { editorTextBoxFuneralHomeLimitPageEntry } from '@/components/admin/EditorTextBoxFuneralHomeLimit/editorTextBoxFuneralHomeLimitPageEntry'
import { apiDocsPageEntry } from '@/components/admin/ApiDocs/apiDocsPageEntry'
import { ApiDocsPage } from '@/components/admin/ApiDocs/ApiDocsPage'
import { transparentPrintBackgroundPageEntry } from '@/components/admin/TransparentPrintBackground/transparentPrintBackgroundPageEntry'
import { TransparentPrintBackgroundPage } from '@/components/admin/TransparentPrintBackground/TransparentPrintBackgroundPage'
import { EditUnauthorized } from '@/components/landing/EditUnauthorized'
import { Landing } from '@/components/landing/Landing'
import { Launch } from '@/components/admin/Launch/Launch'
import { Login } from '@/components/landing/Login/Login'
import { MessengerPressPage } from '@/components/messenger-press/MessengerPressPage'
import { PdfJobsPage } from '@/components/admin/PdfJobs/PdfJobsPage'
import { Package } from '@/components/package/Package'
import { PdfRender } from '@/components/pdfRender/PdfRender'
import { Preview } from '@/components/package/Preview'
import { ProofGallery } from '@/components/proof/ProofGallery'
import { ProofShareGallery } from '@/components/proof/ProofShareGallery'
import { RouteChangeTracker } from '@/components/tracking/RouteChangeTracker'
import { Showcase } from '@/components/docs/Showcase'
import { StatusMessage } from '@/components/admin/StatusMessage/StatusMessage'
import { Support } from '@/components/dashboard/Support/Support'
import { Themes } from '@/components/admin/Themes/Themes'
import { UnderConstructionPage } from '@/components/underConstruction/UnderConstructionPage'

import { Route } from '@/providers/RouteTypes'
import { Triggers } from '@/providers/Triggers'

/**
 * Application routing configuration component.
 * Defines all available routes in the application using react-router-dom.
 *
 * Routes are organized into several sections:
 * - Public routes (landing, login, sign-up)
 * - Dashboard routes (main user interface)
 * - Package and Preview routes
 * - Editor routes
 * - Custom Theme routes
 * - Admin routes (protected administrative functions)
 * - PDF generation routes
 * - Utility routes (under construction)
 * - and Triggers component for global event listeners
 *
 * @component
 * @returns Router component with all application routes
 */
export const Routes = () => (
  <Router>
    {/* Track route changes for analytics and session recording */}
    <RouteChangeTracker>
      {/* landing */}
      <Route exact path="/" component={Landing} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/edit-unauthorized" component={EditUnauthorized} />

      {/* dashboard */}
      <Route exact path="/dashboard" component={Dashboard} />
      <Route exact path="/cases" component={Cases} />
      <Route exact path="/support/:tab" component={Support} />

      {/* package */}
      <Route path="/package" component={Package} />

      <Route path="/preview/:caseId" component={Preview} />

      {/* editor */}
      <Route exact path="/editor/:id" component={Editor} />

      {/* Custom Themes */}
      <Route exact path="/customThemes" component={CustomThemes} />
      <Route
        exact
        path="/customThemes/:id"
        component={CustomThemeEditorWrapper}
      />

      {/* dev */}
      <Route exact path="/showcase" component={Showcase} />
      {/* admin */}
      <Route exact path="/admin" component={AdminHome} />
      <Route exact path="/admin/analytics" component={Analytics} />
      <Route exact path="/admin/assets" component={Assets} />
      <Route exact path="/admin/products" component={AdminProducts} />
      <Route exact path="/admin/status-message" component={StatusMessage} />
      <Route exact path="/admin/themes" component={Themes} />
      <Route exact path="/admin/launch" component={Launch} />
      <Route
        exact
        path="/admin/messenger-press"
        component={MessengerPressPage}
      />
      <Route exact path="/admin/pdf-jobs" component={PdfJobsPage} />
      <Route exact path="/admin/case-image-qc" component={CaseImageQc} />
      <Route
        exact
        path={editorTextBoxFuneralHomeLimitPageEntry.path}
        component={EditorTextBoxFuneralHomeLimitPage}
      />
      <Route
        exact
        path={transparentPrintBackgroundPageEntry.path}
        component={TransparentPrintBackgroundPage}
      />
      <Route exact path={apiDocsPageEntry.path} component={ApiDocsPage} />

      {/* pdf */}
      <Route exact path="/pdfProduct" component={PdfRender} />
      <Route
        exact
        path="/proof-gallery/:pdfId/:token"
        component={ProofGallery}
      />
      <Route exact path="/proof-share/:token" component={ProofShareGallery} />

      {/* Under Construction */}
      <Route
        exact
        path="/under-construction"
        component={UnderConstructionPage}
      />

      {/* always present */}
      <Triggers />
    </RouteChangeTracker>
  </Router>
)

export default Routes
